








































































































































































import { Component, Vue } from "vue-property-decorator";
import http from "@/axios/http-common";
import criticalLabResultService from "@/services/criticalLabResultService";
import CriticalLabResultEventForm from "./CriticalLabResultEventForm.vue";
import CountdownTimer from "./CountdownTimer.vue";

@Component({
  components: { CriticalLabResultEventForm, CountdownTimer }
})
export default class CriticalLabResultList extends Vue {
  events: any[] = [];
  loading = false;
  showForm = false;
  selectedEvent: any = null;
  isEdit = false;
  dashboardData: any = {};
  pendingEvents: any[] = [];

  lisDialog = false;
  lisLoading = false;
  lisCandidates: any[] = [];
  lisError = "";
  lisHeaders = [
    { text: "Pasien", value: "nama_pasien", width: "160" },
    { text: "No. RM", value: "no_rekam_medis", width: "90" },
    { text: "Parameter", value: "parameter_kritis", width: "150" },
    { text: "Nilai", value: "nilai", width: "130", sortable: false },
    { text: "Jam ACC", value: "acc_date", width: "140" },
    { text: "Bangsal", value: "unit_tujuan_id", width: "90" },
    { text: "Aksi", value: "aksi", sortable: false, width: "110" },
  ];

  get capaianPersen(): number {
    return this.dashboardData.capaian_hari_ini ? this.dashboardData.capaian_hari_ini.capaian_persen : 0;
  }

  get capaianNumerator(): number {
    return this.dashboardData.capaian_hari_ini ? this.dashboardData.capaian_hari_ini.numerator : 0;
  }

  get capaianDenominator(): number {
    return this.dashboardData.capaian_hari_ini ? this.dashboardData.capaian_hari_ini.denominator : 0;
  }

  filterBulan = new Date().getMonth() + 1;
  filterTahun = new Date().getFullYear();
  filterStatus = "";
  filterStatusTercapai = "";
  filterUnitLab = "";

  bulanOptions = [
    { text: "Januari", value: 1 }, { text: "Februari", value: 2 }, { text: "Maret", value: 3 },
    { text: "April", value: 4 }, { text: "Mei", value: 5 }, { text: "Juni", value: 6 },
    { text: "Juli", value: 7 }, { text: "Agustus", value: 8 }, { text: "September", value: 9 },
    { text: "Oktober", value: 10 }, { text: "November", value: 11 }, { text: "Desember", value: 12 },
  ];

  statusOptions = [
    { text: "Draft", value: "draft" },
    { text: "Pending Pelaporan", value: "pending_pelaporan" },
    { text: "Reported", value: "reported" },
    { text: "Verified", value: "verified" },
    { text: "Approved", value: "approved" },
  ];

  tercapaiOptions = [
    { text: "Tercapai (< 30 mnt)", value: "tercapai" },
    { text: "Tidak Tercapai", value: "tidak_tercapai" },
  ];

  unitLabOptions = [
    { text: "Patologi Klinik", value: "patologi_klinik" },
    { text: "Mikrobiologi", value: "mikrobiologi" },
    { text: "Patologi Anatomi", value: "patologi_anatomi" },
    { text: "Bank Darah", value: "bank_darah" },
  ];

  headers = [
    { text: "Tanggal", value: "tanggal_pelaporan", width: "100" },
    { text: "Pasien", value: "nama_pasien", width: "150" },
    { text: "No. RM", value: "no_rekam_medis", width: "90" },
    { text: "Nilai Kritis", value: "nilai_kritis", width: "200" },
    { text: "Waktu Pelaporan", value: "waktu_pelaporan_menit", width: "120" },
    { text: "Capaian", value: "status_tercapai", width: "90" },
    { text: "DPJP", value: "dpjp_nama", width: "120" },
    { text: "Status", value: "status", width: "90" },
    { text: "Aksi", value: "actions", sortable: false, width: "100" },
  ];

  mounted() {
    this.loadData();
    this.loadDashboard();
  }

  async loadData() {
    this.loading = true;
    try {
      const params: any = { bulan: this.filterBulan, tahun: this.filterTahun };
      if (this.filterStatus) params.status = this.filterStatus;
      if (this.filterStatusTercapai) params.status_tercapai = this.filterStatusTercapai;
      if (this.filterUnitLab) params.unit_laboratorium = this.filterUnitLab;

      const res = await criticalLabResultService.getEvents(params);
      this.events = res.data?.data || [];
    } catch (e) {
      console.error(e);
    } finally {
      this.loading = false;
    }
  }

  async loadDashboard() {
    try {
      const res = await criticalLabResultService.getDashboard();
      this.dashboardData = res.data?.data || {};
      this.pendingEvents = this.dashboardData.pending_events || [];
    } catch (e) {
      console.error(e);
    }
  }

  tambahBaru() {
    this.selectedEvent = null;
    this.isEdit = false;
    this.showForm = true;
  }

  async openLisPicker() {
    this.lisDialog = true;
    this.lisLoading = true;
    this.lisError = "";
    try {
      const res = await criticalLabResultService.getLisCandidates();
      this.lisCandidates = res.data?.data || [];
      if (res.data?.message) this.lisError = res.data.message;
    } catch (e) {
      console.error(e);
      this.lisCandidates = [];
      this.lisError = "Gagal memuat hasil kritis dari LIS.";
    } finally {
      this.lisLoading = false;
    }
  }

  pickCandidate(item: any) {
    // Prefill form dari kandidat LIS; tanpa id → form akan POST (event baru).
    this.selectedEvent = { ...item };
    this.isEdit = false;
    this.lisDialog = false;
    this.showForm = true;
  }

  formatDateTime(dt: string) {
    if (!dt) return "-";
    return new Date(String(dt).replace(" ", "T")).toLocaleString("id-ID", {
      day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit",
    });
  }

  editEvent(item: any) {
    this.selectedEvent = item;
    this.isEdit = true;
    this.showForm = true;
  }

  viewEvent(item: any) {
    this.selectedEvent = item;
    this.isEdit = false;
    this.showForm = true;
  }

  async cetakPdf(item: any) {
    try {
      const url = process.env.VUE_APP_API_URL + "/lab/critical-result/events/" + item.id + "/pdf";
      const token = sessionStorage.getItem("vue-crm-token") || "";
      const res = await fetch(url, {
        headers: {
          "Authorization": "Bearer " + token,
          "X-Timestamp": String(Math.floor(Date.now() / 1000))
        }
      });
      const blob = await res.blob();
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, "_blank");
    } catch (e) {
      console.error("Gagal cetak PDF", e);
    }
  }

  async hapusEvent(item: any) {
    if (!confirm("Hapus event ini?")) return;
    try {
      await criticalLabResultService.deleteEvent(item.id);
      this.loadData();
    } catch (e) {
      console.error(e);
    }
  }

  formatDate(d: string) {
    if (!d) return "-";
    return new Date(d).toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" });
  }

  flagColor(flag: string) {
    if (flag === "HH") return "red";
    if (flag === "LL") return "blue";
    return "orange";
  }

  statusColor(status: string) {
    const map: any = { draft: "grey", pending_pelaporan: "orange", reported: "blue", verified: "teal", approved: "green" };
    return map[status] || "grey";
  }
}
